/**
 * ISR (Incremental Static Regeneration) 配置
 * 统一管理所有页面的 ISR revalidate 时间
 */

const isProd = process.env.NEXT_APP_ENV === 'production';

// 当前环境
export const ISR_ENV = process.env.NEXT_APP_ENV || 'development';

// 站点域名（从环境变量获取，去掉 https://）
export const SITE_HOST = (process.env.NEXT_APP_WEB_HOST || 'https://www.dolphinradar.com').replace('https://', '');

// 默认 ISR 时间（秒）
export const DEFAULT_REVALIDATE_TIME = isProd ? 600 : 60; // 生产 10分钟，测试 1分钟

// 是否显示 ISR 调试面板
// 目前：仅 development 环境显示
// 后续：如需在 test 环境也显示，将下方 false 改为 true
const isDev = process.env.NEXT_APP_ENV === undefined || process.env.NEXT_APP_ENV === 'development';
const isTest = process.env.NEXT_APP_ENV === 'test';
const SHOW_ISR_DEBUG_IN_TEST = true; // 改为 true 可在 test 环境显示 ISR 面板
export const SHOW_ISR_DEBUG_PANEL = isDev || (isTest && SHOW_ISR_DEBUG_IN_TEST);

// 各页面的 ISR 配置
// key 为自定义标识，注释标明对应的页面路由
export const ISR_CONFIG = {
  // /anonymous-instagram-story-viewer
  'anonymous-instagram-story-viewer': {
    revalidate: isProd ? 600 : 60, // 生产 10分钟，测试 1分钟
  },
  // /instagram-new-follow-tracker
  'instagram-new-follow-tracker': {
    revalidate: isProd ? 600 : 60, // 生产 10分钟，测试 1分钟
  },
  // /instagram-viewer/[id] (动态路由: post-likes, highlights 等)
  'instagram-viewer/[id]': {
    revalidate: isProd ? 600 : 60, // 生产 10分钟，测试 1分钟
  },
  // /web-viewer-for-instagram
  'web-viewer-for-instagram': {
    revalidate: isProd ? 600 : 60, // 生产 10分钟，测试 1分钟
  },
  // /instagram-viewer/post-comments (静态路由)
  'instagram-viewer/post-comments': {
    revalidate: isProd ? 600 : 60, // 生产 10分钟，测试 1分钟
  },
  // /instagram-unfollowers-tracker
  'instagram-unfollowers-tracker': {
    revalidate: isProd ? 600 : 60, // 生产 10分钟，测试 1分钟
  },
  // / (首页)
  home: {
    revalidate: isProd ? 600 : 60, // 生产 10分钟，测试 1分钟
  },
  // /ig-follower-export-tool
  'ig-follower-export-tool': {
    revalidate: isProd ? 600 : 60, // 生产 10分钟，测试 1分钟
  },
} as const;

// 获取指定页面的 revalidate 时间
export function getRevalidateTime(pageName: keyof typeof ISR_CONFIG): number {
  return ISR_CONFIG[pageName]?.revalidate ?? DEFAULT_REVALIDATE_TIME;
}
